var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{attrs:{"padless":"","id":"contact-footer"}},[_c('v-card',{staticClass:"text-center",attrs:{"flat":"","tile":"","width":"100%"}},[_c('CompanyInformation'),_c('CopyRight')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }